import React from 'react';
import '../styles/AlertMessage.css';

const AlertMessage = ({ type, message, onClose }) => {
  return (
    <div className={`alert alert-${type}`}>
      <div className="alert-content">
        <span>{message}</span>
      </div>
      <button className="alert-close" onClick={onClose}>×</button>
    </div>
  );
};

export default AlertMessage;